import {ALARM, PROJECT} from "../apiConstant";
import BaseApi from "../baseApi";

class AlarmApi extends BaseApi {
  constructor() {
    super();
    this.BASE_URL = process.env.REACT_APP_PROJECT_MANAGEMENT_API_URL || "";
    this.$axiosInstance = this.initAxiosInstance();
  }

  getList(body) {
    return this.post(`${ALARM}/list`, body);
  }

  changeAlarmParticipant(alarmCode) {
    return this.post(`${ALARM}/read-alarm/${alarmCode}`);
  }

  changeAlarmParticipantList() {
    return this.post(`${ALARM}/read-alarms`);
  }

}
export default AlarmApi;
